import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HiddenMessage = ({
  title,
  body = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-message-history.common-message.hiddenMessage.body"
  }),
  tooltip
}) => {
  return /*#__PURE__*/_jsxs(Alert, {
    type: "info",
    titleText: title,
    children: [body, tooltip && /*#__PURE__*/_jsx(HelpIcon, {
      title: tooltip,
      marginInlineStart: "100"
    })]
  });
};
HiddenMessage.displayName = 'HiddenMessage';
export default HiddenMessage;